const commentItems = [
  {
    name: '光影猎人',
    date: '3天前',
    text: '画质真的绝了！4K蓝光版本看《星际迷航》简直就是一种享受，每个细节都清晰可见。而且完全没有广告，观影体验比主流平台好太多了。',
    tag: '4K画质党',
  },
  {
    name: '剧荒终结者',
    date: '5天前',
    text: '片库太全了，我想看的国产老剧和新出的韩剧这里都有。更新速度也很快，基本院线下线一周内就能看到高清版本，推荐给了好多朋友。',
    tag: '资深剧迷',
  },
  {
    name: '电影日记本',
    date: '1周前',
    text: '作为一个每天刷一部电影的影迷，90影视的播放流畅度让我很惊喜。用了三个月了，从没遇到过卡顿，晚上高峰期也一样流畅。',
    tag: '每日影迷',
  },
  {
    name: '周末观影家',
    date: '1周前',
    text: '全家一起看电影的周末仪式感就靠90影视了。动画片、纪录片、合家欢喜剧应有尽有，高清画质在大电视上看着特别舒服，孩子们也很喜欢。',
    tag: '家庭用户',
  },
];

const carouselItems = [
  {
    title: '科幻宇宙：从经典到未来',
    desc: '从《2001太空漫游》到《星际迷航：新纪元》，科幻电影如何塑造我们对宇宙的想象？本文深度盘点科幻电影六十年发展史。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Epic%20space%20exploration%20scene%20with%20spaceship%20approaching%20a%20massive%20ringed%20planet%2C%20nebula%20colors%20in%20deep%20space%2C%20cinematic%20sci-fi%20composition%2C%20dramatic%20cosmic%20lighting%2C%20film%20poster%20aesthetic%2C%20dark%20background%20with%20vibrant%20star%20field&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '港片黄金年代：那些年我们一起追的经典',
    desc: '香港电影在上世纪八九十年代达到巅峰，动作、警匪、喜剧百花齐放。90影视4K修复计划让这些经典焕发新生。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20at%20night%20with%20glowing%20neon%20signs%2C%20classic%20red%20taxi%2C%20wet%20pavement%20reflections%2C%20cinematic%20urban%20scene%2C%20warm%20and%20cool%20tone%20contrast%2C%20nostalgic%20Hong%20Kong%20cinema%20vibe&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑烧脑季：挑战智商的十部神作',
    desc: '反转再反转，结局出乎意料。我们精选了近年评分最高的悬疑电影，每一部都值得反复观看，细节中藏着真相。',
    tag: '精选影单',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20cork%20board%20covered%20in%20red%20string%20connections%2C%20photographs%20and%20notes%2C%20film%20noir%20lighting%20with%20blinds%20shadows%2C%20warm%20desk%20lamp%20glow%2C%20atmospheric%20crime%20investigation%20scene&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '自然的力量：不可错过的纪录片推荐',
    desc: '从深海到雪山，从雨林到极地。用4K超清画质打开自然世界的大门，每一帧都是绝美壁纸。',
    tag: '纪录精选',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20vast%20African%20savanna%20with%20wildlife%20herds%20at%20golden%20sunset%2C%20dramatic%20cloud%20formations%2C%20warm%20atmospheric%20light%2C%20documentary%20film%20aesthetic%2C%20epic%20natural%20landscape%20photography&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '国产剧崛起：2026不容错过的好剧',
    desc: '国产剧集质量持续攀升，从古装正剧到现实题材，优质内容层出不穷。90影视全程高清收录，为您盘点年度必看剧集。',
    tag: '剧集盘点',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20film%20production%20set%20with%20professional%20lighting%20equipment%20and%20camera%20rig%2C%20warm%20cinematic%20studio%20atmosphere%2C%20behind%20the%20scenes%20aesthetic%2C%20dramatic%20spotlight%20effects%2C%20contemporary%20Chinese%20drama%20production&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

const indexItems = [
  { title: '动作电影', count: '2,856部', icon: 'ri-sword-line' },
  { title: '科幻电影', count: '1,423部', icon: 'ri-rocket-line' },
  { title: '悬疑电影', count: '2,104部', icon: 'ri-search-eye-line' },
  { title: '喜剧电影', count: '3,217部', icon: 'ri-emotion-laugh-line' },
  { title: '爱情电影', count: '2,689部', icon: 'ri-heart-line' },
  { title: '恐怖电影', count: '987部', icon: 'ri-ghost-line' },
  { title: '纪录电影', count: '1,856部', icon: 'ri-camera-line' },
];

const faqItems = [
  {
    q: '90影视是否需要注册才能观看？',
    a: '不需要。90影视所有影视资源均可免费在线观看，无需注册账号。我们致力于为用户提供最便捷的观影体验，打开网站即可畅享高清超清4K蓝光1080P画质的电影电视剧全集。',
  },
  {
    q: '为什么有些影片加载速度较慢？',
    a: '90影视采用全球CDN智能调度与自适应码率技术，正常情况下播放流畅无缓冲。如遇加载缓慢，请检查您的网络连接或尝试切换清晰度。我们持续优化服务器节点，确保观影体验。',
  },
  {
    q: '90影视的资源画质如何？',
    a: '90影视以画质为核心竞争力，全站资源支持高清超清4K蓝光1080P等多种画质标准。我们优先收录高品质片源，部分经典影片已进行4K数字修复处理，为您带来极致的视觉体验。',
  },
  {
    q: '90影视有移动端App吗？',
    a: '目前90影视提供Android和iOS客户端下载，支持DLNA投屏与画中画播放功能。移动端适配手机与平板设备，让您随时随地享受高清观影体验。',
  },
];

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/40">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-accent-400 uppercase tracking-wider">用户反馈</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">用户热评</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {commentItems.map((item, i) => (
            <div key={i} className="bg-background-50 border border-background-200/40 rounded-lg p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-500/10 flex items-center justify-center text-primary-400 font-label text-sm">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm text-foreground-800 font-label font-medium">{item.name}</p>
                  <p className="text-xs text-foreground-500 font-label">{item.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">&ldquo;{item.text}&rdquo;</p>
              <span className="text-xs text-primary-400 font-label bg-primary-500/10 px-2 py-0.5 rounded-full">{item.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-primary-400 uppercase tracking-wider">深度内容</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">焦点专题</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item, i) => (
            <div key={i} className="group cursor-pointer bg-background-100/60 border border-background-200/40 rounded-lg overflow-hidden hover:border-background-300/60 transition-colors">
              <div className="relative overflow-hidden aspect-[16/10] bg-background-100">
                <img
                  src={item.img}
                  alt={`90影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i > 0 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-label bg-accent-500 text-background-50 rounded">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm text-foreground-950 font-label font-medium mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4">
          {carouselItems.slice(3, 5).map((item, i) => (
            <div key={i + 3} className="group cursor-pointer bg-background-100/60 border border-background-200/40 rounded-lg overflow-hidden hover:border-background-300/60 transition-colors flex flex-col sm:flex-row">
              <div className="relative overflow-hidden sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-auto bg-background-100">
                <img
                  src={item.img}
                  alt={`90影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex flex-col justify-center">
                <span className="px-2 py-0.5 text-[10px] font-label bg-accent-500 text-background-50 rounded self-start mb-2">{item.tag}</span>
                <h3 className="text-sm text-foreground-950 font-label font-medium mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/40">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-accent-400 uppercase tracking-wider">分类导航</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">主题索引</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/40 rounded-lg p-4 text-center cursor-pointer hover:border-primary-500/20 hover:bg-background-200/20 transition-colors group"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm text-foreground-800 font-label font-medium mb-1">{item.title}</h3>
              <span className="text-xs text-foreground-500 font-label">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-400 uppercase tracking-wider">帮助中心</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">常见问题</h2>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-100/60 border border-background-200/40 rounded-lg p-5">
              <h3 className="text-sm text-foreground-950 font-label font-medium mb-2">
                <span className="text-primary-400 mr-2">Q{i + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function SocialProofGroup() {
  return (
    <>
      <CommentsSection />
      <CarouselSection />
      <IndexSection />
      <FAQSection />
    </>
  );
}